<template>
    <div class="tutorial-pages-container">
        <div class="tutorial-pages" :style="{transform: 'translateX(' + pageIndex * -100 + '%'}">
            <div v-for="(page,key) in pages" :key="key" class="tutorial-page">
                <div class="media-wrapper">
                    <img v-if="page.media.type == 'img'" :src="getMedia('tutorial/' + page.media.url)" alt=""> 
                    <video v-if="page.media.type == 'video'" :src="getMedia('tutorial/' + page.media.url)" autoplay loop muted/>
                    <div v-if="page.media.type == 'none'" class="no-media">
                        <img :src="getMedia('logos/Aliaxis_logo.png')" alt=""> 
                    </div>
                </div>
    
                <!-- Text -->
                <div class="text-wrapper">
                    <p>{{ t(page.text) }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { getMedia } from '@/util';

const { t } = useI18n();

const props = defineProps({
    pageIndex: { type: Number, required: true },
    pages: { type: Array<{
        media: {
            type: string;
            url: string;
        };
        text: string;
    }>, required: true },
});
</script>

<style lang="scss" scoped>
.tutorial-pages-container{
    position: relative;
    width: 100%;
    flex: 1 1 auto;
    min-height: 0;
}

.tutorial-pages{
    height:100%;
    display: flex;
    transition: .3s ease-in-out;

    .tutorial-page {
        height:100%;
        width:100%;
        display: flex;
        flex-direction: column;
        align-items: stretch;
        flex:0 0 auto;

        .media-wrapper {
            position: relative;
            width: 100%;
            height: 100%;
            overflow: hidden;
            display: flex;
            justify-content: center;

            &>* {
                width: 100%;
            }

            .no-media {
                display: flex;
                justify-content: center;
                align-items: center;
                height: 280px;
                img {
                    height: 64px;
                }
            }

            img, video {
                object-fit: cover;
            }
        }

        .text-wrapper{
            height: 40%;
            flex-grow: 1;
            overflow: auto;

            p {
                margin: 0;
                font-size: 1.25rem;
                padding: 1rem 2rem;
            }
        }
    }
}
</style>